/**
 * Signup flow modes. FULL is the existing multi-step wizard; TRIMMED is the single-step
 * eCommerce signup that captures only essentials and defers KYC/banking/address verification
 * to post-signup flows.
 */
export enum SignupMode
{
    FULL = 'FULL',
    TRIMMED = 'TRIMMED'
}
